import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutHeaderComponent } from './layout-header.component';
import { RouterModule } from '@angular/router';
import { LayoutHeaderMainContentDirective, LayoutHeaderRightContentDirective } from './layout-header-templates';
import { LayoutHeaderIconComponent } from './layout-header-icon/layout-header-icon.component';
import { LayoutHeaderFlyoutMenuComponent } from './layout-header-flyout-menu/layout-header-flyout-menu.component';
import { LayoutHeaderNotificationCenterComponent } from './layout-header-notification-center/layout-header-notification-center.component';
import { NewsEntryComponent } from './layout-header-notification-center/news-entry/news-entry.component';
import { SharedModule } from '../../helper/shared.module';
import { HotspotModule } from '@gridscale/ingrid/components/hotspot';
import { A11yLinkDirective } from '../../helper/directives/a11ylink.directive';
import { A11yFocusDirective } from '../../helper/directives/a11yfocus.directive';



@NgModule({
  declarations: [
    LayoutHeaderComponent,
    LayoutHeaderMainContentDirective,
    LayoutHeaderRightContentDirective,
    LayoutHeaderFlyoutMenuComponent,
    LayoutHeaderIconComponent,
    LayoutHeaderNotificationCenterComponent,
    NewsEntryComponent
  ],
  imports: [
    A11yFocusDirective,
    A11yLinkDirective,
    CommonModule,
    RouterModule,
    SharedModule,
    HotspotModule
  ],
  exports: [
    LayoutHeaderComponent,
    LayoutHeaderMainContentDirective,
    LayoutHeaderRightContentDirective,
    LayoutHeaderFlyoutMenuComponent,
    LayoutHeaderIconComponent,
    LayoutHeaderNotificationCenterComponent,
    NewsEntryComponent
  ]
})
export class LayoutHeaderModule { }
